import { Modal } from "antd";
import { useState } from "react";

const NewVersionModal = ({
  setShowModal,
  showModal,
}: {
  setShowModal: (showModal: boolean) => void;
  showModal: boolean;
}) => {
  const [updating, setUpdating] = useState(false);

  const hideModal = () => {
    setShowModal(false);
  };

  const confirm = () => {
    setUpdating(true);
    setTimeout(() => {
      window.location.href = "/new-version";
    }, 1000);
  };

  return (
    <>
      <Modal
        centered
        title="Update Available"
        maskClosable={false}
        destroyOnClose
        open={showModal}
        onOk={confirm}
        okButtonProps={{ loading: updating }}
        cancelButtonProps={{ disabled: updating }}
        onCancel={hideModal}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>
          Once you confirm, you will be logged out. Make sure you have saved
          your work.
        </p>
      </Modal>
    </>
  );
};

export default NewVersionModal;
